import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';
import Hint from './Hint';
import './MultiStateSwitch.sass';

class MultiStateSwitch extends Component {
  constructor(props) {
    super(props);
    const key = 0;
    // if (props.default) {
    //   for (let i = 0; i < props.types.length; i++) {
    //     if (props.types[i].value === props.default) {
    //       key = i;
    //       break;
    //     }
    //   }
    // }
    this.state = { key };
    this.handleSwitchState = this.handleSwitchState.bind(this);
  }

  handleSwitchState(key) {
    const { onStateChange, types } = this.props;
    this.setState({ key });

    /* Invoke the onStateChange event */
    onStateChange({ title: types[key].title, value: types[key].value });
  }

  render() {
    const {
      showTitle,
      showHint,
      types,
      hint,
      hintConfig,
      style,
      value
    } = this.props;
    let { key } = this.state;

    /* If value specified, it will override the inner-state of the component */
    if (value) {
      for (let i = 0; i < types.length; i += 1) {
        if (types[i].value === value) {
          key = i;
          break;
        }
      }
    }
    const currentType = types[key];

    return (
      <div className="MultiStateSwitch" style={{ border: `1pt solid ${currentType.color || 'transparent'}`, ...style }}>
        {
          /* Render Buttons */
          types.map(({
            title,
            fontAwesomeIcon,
            iconStyle,
            content
          }, i) => (
            <Tooltip
              key={i}
              content={title}
              position="bottom"
            >
              <span
                className="switch-unit"
                onClick={() => this.handleSwitchState(i)}
              >
                {
                  fontAwesomeIcon ?
                    <span style={{ pointerEvents: 'none', ...iconStyle }} className={`fa fa-${fontAwesomeIcon}`} /> :
                    content
                }
              </span>
            </Tooltip>
          ))
        }

        {
          showTitle ? (
            <span className="switch-info" style={{ backgroundColor: currentType.color || 'transparent' }}>
              {currentType.title}
            </span>
          ) : undefined
        }

        {
          showHint ? <Hint {...hintConfig}>{hint}</Hint> : undefined
        }

        <span
          className="switch-pointer"
          style={{
            left: `${15 + (28 * key) + 4}pt`
          }}
        />
      </div>
    );
  }
}

MultiStateSwitch.propTypes = {
  types: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    fontAwesomeIcon: PropTypes.string,
    color: PropTypes.string,
    iconStyle: PropTypes.object,
    content: PropTypes.any
  })).isRequired,
  showTitle: PropTypes.bool,
  showHint: PropTypes.bool,
  hint: PropTypes.any,
  hintConfig: PropTypes.object,
  style: PropTypes.object,
  onStateChange: PropTypes.func,
  value: PropTypes.string
};

MultiStateSwitch.defaultProps = {
  showTitle: true,
  showHint: true,
  hint: 'This is hint ...',
  hintConfig: {},
  style: {},
  value: null,
  onStateChange() { }
};

export default MultiStateSwitch;



// WEBPACK FOOTER //
// ./src/components/MultiStateSwitch.jsx